import { useCallback, useEffect, useState } from 'react';
import { useIntersection } from 'react-use';

import useThrottledWindowScrollPosition from 'hooks/useThrottledWindowScrollPosition';
import setStickyButtonHeightCssVar from 'commons/setStickyButtonHeightCssVar';
import useScreen from 'hooks/useScreen';

const useShowStickyButtons = addToBagSectionRef => {
  const { isMobileOrTablet } = useScreen();
  const intersection = useIntersection(addToBagSectionRef, {});
  const isIntersecting = intersection?.isIntersecting;
  const [scrollPositionY, setScrollPositionY] = useState(0);
  const [showStickyButtons, setShowStickyButtons] = useState(false);

  const onThrottledWindowScrollPositionChange = useCallback(({ y }) => {
    setScrollPositionY(y);
  }, []);

  useThrottledWindowScrollPosition({
    callback: onThrottledWindowScrollPositionChange,
  });

  useEffect(() => {
    if (addToBagSectionRef.current) {
      const {
        offsetTop: topOfAddToBagFromViewport,
      } = addToBagSectionRef.current;

      if (!isIntersecting && scrollPositionY > topOfAddToBagFromViewport) {
        setShowStickyButtons(true);
        // Set Css var to control Hero button placement
        if (isMobileOrTablet) {
          setStickyButtonHeightCssVar(100);
        }
      } else {
        setShowStickyButtons(false);
        if (isMobileOrTablet) {
          setStickyButtonHeightCssVar(11);
        }
      }
    }
  }, [isIntersecting, scrollPositionY, addToBagSectionRef, isMobileOrTablet]);

  return showStickyButtons;
};

export default useShowStickyButtons;
